<template>
    <div ref="root">
        <slot v-if="shouldRender"></slot>
        <slot v-if="!shouldRender" name="fallback"></slot>
    </div>
</template>

<script>import script from './Lazy';
    export default script;</script>
